import { render, staticRenderFns } from "./CollectListSearchLayout.vue?vue&type=template&id=4e4c37c6&scoped=true"
import script from "./CollectListSearchLayout.vue?vue&type=script&lang=js"
export * from "./CollectListSearchLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e4c37c6",
  null
  
)

export default component.exports